const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function scheduledCashflowOrigin(externalActivityId) {
  const parts = String(externalActivityId ?? "").trim().split(":");
  if (parts.length < 4 || parts[0] !== "fp-scheduled-cash") return null;

  const [, positionId, eventKind] = parts;
  return UUID_PATTERN.test(positionId) && eventKind
    ? { positionId, eventKind }
    : null;
}

export function scheduledCashflowOriginReference(notes) {
  const value = String(notes ?? "").trim();
  if (!value) return "";

  const match = value.match(
    /(?:scheduled cashflow deposit for|cash deposit for scheduled activity on)\s+(.+?)(?:\.\s*)?$/i
  );
  return String(match?.[1] || "").trim();
}
